import AllProducts from "../components/AllProducts"
import Base from "../components/Base"
import Product from "../components/Product"
import ProductNavbar from "../components/ProductNavbar"

const Home=()=>{
    return(
        <Base>
            
            <AllProducts></AllProducts>
        </Base>
    )
}

export default Home